import { useNavigate } from "react-router-dom";
import {motion} from "motion/react";
import { ArrowRight } from "lucide-react";
export default function About(){
    const navigate = useNavigate(); 

    const aboutus = [
        {
         title: "About platform",
         content: "We`have build a new platform for fanfics readers and authors. We use an AI intelegence for make better your experience. At Storii you`ll find a lot of stories. Now you can register for a beta version and we`ll notify you about first version"
        },
        {
           title: "About our team",
           content: "Our team is`nt big, but we are strong people which want to build future better then past. We have a new vision and we want to share that."
        }
    ];

    return (
        <div className="w-full bg-white p-6 py-24">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            About us
          </h2>
          <p className="text-lg text-gray-500">
            We are a powerful enthusiast team
          </p>
        </motion.div>

        <div className="space-y-8 mb-16">
          {aboutus.map((about, index) => (
            <motion.div
              key={about.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                {about.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {about.content}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center bg-gradient-to-br from-gray-50 to-purple-50 rounded-3xl p-12 border border-gray-200"
        >
          <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6">
            Now you can register to Waitlist
          </h3>
          <button onClick={() => navigate('/waitlist')} className="group px-10 py-5 bg-black text-white rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 inline-flex items-center gap-3">
            <span>Register Now</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </div>
    );
}